import { useState } from 'react'

import classNames from 'classnames'

import styles from './statistic_cards.module.sass'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Stat from './stat'
import Image from './basic/image'

function StatisticCards(props) {
	const fields = props.fields
	const [items, setItems] = useState(fields.statistics.map(obj => ({ ...obj, animate: false})))
	
	return <BlockWrapper className={classNames(styles.statistics_cards)}>
			<ScrollAnimation styles={styles}>
				<div className={styles.statistics_cards_wrapper}>
						{items && items.map((item, index) => {
							return <div className={styles.card} key={index}>
								<div className={styles.title}>
									{item.title && <div className={styles.stat_wrapper}><Stat value={item.title} animate={index == 0 ? true : item.animate} /></div>}
									{item.image && <div className={styles.image_wrapper}><Image className={styles.image} {...item.image} /></div>}
								</div>
								<div className={styles.description} dangerouslySetInnerHTML={{ __html: item.description}} />
								<div className={styles.footnotes}>
									{item.footnotes && item.footnotes.map((footnote, i) => {
										return <div className={classNames(styles.footnote)} key={i} dangerouslySetInnerHTML={{ __html: `<sup>${footnote.reference_number}</sup>${footnote.note}`}} />
									})}
								</div>
							</div>
						})}
					</div>
			</ScrollAnimation>
	</BlockWrapper>
}

export default StatisticCards